const messages = {
    helloWorld: "Hello world {ts, date, ::yyyyMMdd}",
}

export default messages